import React, { useEffect, useState } from 'react';
import { Dialog, BodyText, Button } from '@paypalcorp/pp-react';
import { CountdownTimer } from './CountdownTimer';
import { launchRedirect } from '../../lib/validate';
import * as FPT from '../../utility/fpt';
import { parseMessages } from '../../utilityHelper';
import { extendSessionAPI, addActivityListeners, removeActivityListeners } from '../../common/extendSessionUtils';
import withTheme from '../../common/withTheme';
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme';
const { sysColorAccent2Main } = PAYPAL_THEME;
 const ExtendSession = (props) => {
    const { heartbeatInterval = 1000, scaCountry, basePage } = props;
    const messages = parseMessages('givingfund');
    // Session time should last 5 or 15 minutes according to the region
    const countryTimeout = scaCountry ? 5 : 15;
    const confirmTime = (countryTimeout - 2) * 60 * 1000;
    const expireTime = countryTimeout * 60 * 1000;
    const activityFrame = 1 * 60 * 1000;

    const [isOpen, setIsOpen] = useState(false);
    const [isTimeout, setIsTimeout] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [isActivityListenersAdded, setIsActivityListenerersAdded] =
        useState(false);
    const [lastActivityAt, setLastActivityAt] = useState(Date.now());
    const requestExtendSession = async () => {
        FPT.trackButtonClick('extendSessionBtn');
        if (isSending) return;
        setIsSending(true);
        try {
            await extendSessionAPI({ currentStep: props.currentStep });
        } catch (e) {
            launchRedirect('/givingfund/profile');
        }
        setLastActivityAt(Date.now());
        setIsSending(false);
        setIsOpen(false);
    };

    const setUserActivityDetected = () => {
        removeActivityListeners(setUserActivityDetected);
        requestExtendSession();
        setIsActivityListenerersAdded(false);
    };

    const fetchCallListener = () => {
        setLastActivityAt(Date.now());
    };

    useEffect(() => {
        const heartbeat = setInterval(async () => {
            let currentTime = Date.now();
            if (currentTime - lastActivityAt > confirmTime) {
                removeActivityListeners(setUserActivityDetected);
                setIsActivityListenerersAdded(false);
                if (!isOpen) {
                    FPT.trackAjaxPageLoad('AjaxLoad', `main:givingfund:profile`, `main:givingfund:${basePage}|extendSessionModal`);
                    setIsOpen(true);
                }
            } else if (currentTime - lastActivityAt > confirmTime - activityFrame) {
                if (!isActivityListenersAdded) {
                    addActivityListeners(setUserActivityDetected);
                    setIsActivityListenerersAdded(true);
                }
            }
        }, heartbeatInterval);

        document.addEventListener('fetchCall', fetchCallListener);

        // Clear window events if the component is unmounted
        return () => {
            clearInterval(heartbeat);
            document.removeEventListener('fetchCall', fetchCallListener);
        };
    }, [lastActivityAt, isOpen]);

    useEffect(() => {
        if (isTimeout) {
            launchRedirect('/givingfund/profile');
        }
    }, [isTimeout]);

    return (
        
            <Dialog
                isOpen={isOpen}
                onClose={requestExtendSession}
                closeButtonLabel={messages.profile.cancel}
                center
            >
                <div style={{ marginBottom: '2rem' }}>
                    <img src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-warning.svg" width="72px" height="72px" alt={messages.profile.sessionModal.warningIcon} />
                </div>
                <CountdownTimer
                    expireTime={expireTime}
                    lastActivity={lastActivityAt}
                    pause={isSending}
                    onTimeout={setIsTimeout}
                styles={{ color: sysColorAccent2Main }} />
                <BodyText style={{ margin: '1.5rem 0' }}>{messages.profile.sessionModal.body}</BodyText>
                <Button btnState={isSending ? 'processing' : 'initial'} onClick={requestExtendSession} style={{ 'marginBottom': '60px' }}>{messages.profile.sessionModal.continueBtn}</Button>
            </Dialog>
    );
};

export default withTheme(ExtendSession);